import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthProvider } from '@cloudpremise/portal_core';
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import Card from "@mui/material/Card";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import SetupFormWizard from "./SetupTabs/SetupFormWizard";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";

import "../styles/formbuilder.scss";

const Setup = (props) => {
    const [ authorized ] = useAuthProvider();
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    const navigate = useNavigate();
    let defaultState = {
        currentTab: 0,
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing", { replace: true });
        }
        if(user === null || !user.superAdmin){
            return navigate("/servicedesk/cases", { replace: true });
        }
    });

    function onTabChange(tab){
        setState({
            currentTab: parseInt(tab)
        });
    }
    
    if(user === null || !user.superAdmin){
        return null;
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={config.hideLayout ? 0 : 3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={12} lg={12} ml="auto" mr="auto" position="relative">
                        <MDBox component="form" role="form">
                            <Card style={{borderRadius: "xs"}}>
                                <Tabs
                                    orientation="horizontal"
                                    value={state.currentTab}
                                    onChange={(event, tab) => onTabChange(tab)}
                                    variant="standard"
                                >
                                    <Tab
                                        label="Configure Service Desk Intake Form"
                                    />
                                </Tabs>
                                <MDBox p={2} mt={1} className={"formbuilder builder-type-"+state.formType}>
                                    {
                                        state.currentTab === 0 ?
                                            <SetupFormWizard objectType="Case" />
                                        :
                                        null
                                    }
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
};

export default Setup;